
import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import Calendar from '@/components/Calendar.vue'
import BasicBoard from '@/components/BasicBoard.vue'
import { SchoolNoticeVO, SchoolNoticeSlvVO } from '@/views/biz/notice/vo/CalendarVO'
import { BoardIVO, BoardOVO } from '@/views/biz/board/vo/BoardVO'
import { CommonCodeIVO, CommonCodeOVO } from '@/views/bizcommon/code/vo/CodeVO.vo'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'

@Component({
  components: {Calendar, BasicBoard}
})
export default class Main extends Vue {
  notice: SchoolNoticeVO = {} as SchoolNoticeVO;
  schedules: Array<SchoolNoticeSlvVO> = [] as Array<SchoolNoticeSlvVO>;
  pageVO: BoardIVO = {} as BoardIVO;
  boards: Array<BoardOVO> = [];
  member: MemberVO = {} as MemberVO;
  majorNotice = [];

  created(): void {
    axios.get('/member')
    .then(r => {
      if(r.data) {
        this.member = r.data;
      }
    })

    // 학교 주요 소식
    const currentDate = new Date();
    axios.get(`/notice/school/summary`)
    .then(r => {
      this.schedules = r.data;
    })

    // 최신 정보글
    this.pageVO.startNum = 0;
    this.pageVO.limit = 3;
    axios.get('/board/boards', {params: this.pageVO})
    .then(r => {
      this.boards = r.data;
    })

    // 최근 채점 내역

    // 현재 과목 정보

  }
}
